{
  "version": 1,
  "asset_id": "f86b4426-c6d0-43c5-b8e1-cb027b3bd34e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f86b4426-c6d0-43c5-b8e1-cb027b3bd34e/loc-georgetown-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f86b4426-c6d0-43c5-b8e1-cb027b3bd34e/loc-georgetown-640.avif",
  "original_filename": "loc-georgetown-640.avif",
  "size": 21970,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:27Z"
}
